/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EligibilitySubmissionFileDetail {
  id?: string;
  rowId?: number;
  datasetId?: string;
  eligibilitySubmissionFileId?: string;
  transactionSetNumber?: number;
  patientId?: string;
  insuranceId?: string;
  serviceDate?: string | null;
  sequenceNumber?: number;
  insuranceRowNumber?: number;
  eligibilityResponseFileId?: string | null;
  responseReceivedDate?: string | null;
  isDeleted?: boolean;
  deletedBy?: string | null;
  deletedDate?: string | null;
  createdBy?: string | null;
  createdDate?: string;
  updatedBy?: string | null;
  updatedDate?: string | null;
}
